export const filterPokemons = (pokemons, { filter = '', count }) => {

    return pokemons.filter(({ name }) => {
        return name.toLowerCase().includes(filter.toLowerCase());
    }).slice(0, count);
};